var render, staticRenderFns
import script from "./customerListTable.vue?vue&type=script&lang=js&"
export * from "./customerListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b00ed5e",
  null
  
)

export default component.exports